import i18n from '@i18n'

export const INVOICE_LIST_COLUMNS = [
  {
    title: i18n.t('invoice.orderNo'),
    key: 'order_no',
    width: 180,
    slot: 'order_no',
  },
  {
    title: i18n.t('invoice.aliOrderNo'),
    key: 'ali_order_no',
    width: 220,
  },
  {
    title: i18n.t('invoice.product'),
    key: 'product_names',
    width: 200,
    slot: 'product_names',
  },
  {
    title: i18n.t('invoice.totalPayment'),
    key: 'amount',
    width: 110,
    ellipsis: true,
    slot: 'amount',
  },
  {
    title: i18n.t('invoice.refundAmount'),
    key: 'refund_count',
    width: 140,
    slot: 'refund_count',
    ellipsis: true,
  },
  {
    title: i18n.t('invoice.isOnlineInvoice'),
    key: 'order_invoice_type_str',
    width: 120,
  },
  {
    title: i18n.t('invoice.invoiceType'),
    key: 'invoice_type',
    width: 140,
    slot: 'invoice_type',
  },
  {
    title: i18n.t('invoice.invoiceNo'),
    key: 'invoice_no',
    width: 180,
    slot: 'invoice_no',
  },
  {
    title: i18n.t('invoice.invoiceAmount'),
    key: 'invoice_amount',
    width: 110,
    slot: 'invoice_amount',
  },
  {
    title: i18n.t('invoice.invoiceDate'),
    key: 'invoice_date',
    width: 180,
    slot: 'invoice_date',
  },
  {
    title: i18n.t('invoice.billType'),
    key: 'bill_type',
    width: 100,
    slot: 'bill_type',
  },
  {
    title: i18n.t('invoice.invoiceStatus'),
    key: 'status',
    minWidth: 110,
    slot: 'status',
  },
  {
    title: i18n.t('invoice.operation'),
    key: 'operation',
    width: 205,
    slot: 'operation',
    fixed: 'right',
  }
]

export const INVOICE_DETAIL_COLUMNS = [
  {
    title: i18n.t('invoice.orderNo'),
    key: 'order_no',
    width: 180,
    slot: 'order_no',
  },
  {
    title: i18n.t('invoice.aliOrderNo'),
    key: 'ali_order_no',
    width: 220,
  },
  {
    title: i18n.t('invoice.product'),
    key: 'product_names',
    width: 200,
    slot: 'product_names',
  },
  {
    title: i18n.t('invoice.transferInAmount'),
    key: 'transfer_in_amount',
    width: 120,
    ellipsis: true,
    slot: 'transfer_in_amount',
  },
  {
    title: i18n.t('invoice.supplementAmount'),
    key: 'supplement_amount',
    width: 120,
    ellipsis: true,
    slot: 'supplement_amount',
  },
  {
    title: i18n.t('invoice.totalPayment'),
    key: 'amount',
    width: 110,
    ellipsis: true,
    slot: 'amount',
  },
  {
    title: i18n.t('invoice.refundAmount'),
    key: 'refund_count',
    width: 140,
    slot: 'refund_count',
    ellipsis: true,
  },
  {
    title: i18n.t('invoice.isOnlineInvoice'),
    key: 'order_invoice_type_str',
    width: 120,
  },
  {
    title: i18n.t('invoice.invoiceType'),
    key: 'invoice_type',
    width: 140,
    slot: 'invoice_type',
  },
  {
    title: i18n.t('invoice.invoiceNo'),
    key: 'invoice_no',
    width: 180,
    slot: 'invoice_no',
  },
  {
    title: i18n.t('invoice.invoiceAmount'),
    key: 'invoice_amount',
    width: 110,
    slot: 'invoice_amount',
  },
  {
    title: i18n.t('invoice.invoiceDate'),
    key: 'invoice_date',
    width: 180,
    slot: 'invoice_date',
  },
  {
    title: i18n.t('invoice.billType'),
    key: 'bill_type',
    width: 100,
    slot: 'bill_type',
  },
  {
    title: i18n.t('invoice.invoiceStatus'),
    key: 'status',
    minWidth: 110,
    slot: 'status',
  },
  {
    title: i18n.t('invoice.operation'),
    key: 'operation',
    width: 205,
    slot: 'operation',
    fixed: 'right',
  }
]

/**
 * 发票操作类型枚举
 * @enum {number}
 * @property {number} APPLY - 5: 申请开票
 * @property {number} RED_PROCESS - 6: 红冲处理
 * @property {number} RED_CONFIRM - 7: 我已确认
 * @property {number} TO_CONFIRM - 8: 去电子税务局确认
 * @property {number} DOWNLOAD - 9: 下载发票
 * @property {number} VIEW_DETAIL - 10: 查看详情
 * @property {number}  - 13: 重开申请
 * @property {number}  - 15: 取消重开
 */
export const INVOICE_OPERATES = {
  APPLY: 5,
  RED_PROCESS: 6,
  RED_CONFIRM: 7,
  TO_CONFIRM: 8,
  DOWNLOAD: 9,
  VIEW_DETAIL: 10,
  REOPEN: 13,
  CANCEL_REOPEN: 15,
}

export const INVOICE_TYPES = {
  FORMAL: '5',
  SPECIAL: '4',
  GENERAL: '3',
}

export const INVOICE_TYPE_OPTIONS = [
  { label: i18n.t('invoice.digitalSpecial'), value: '4' },
  { label: i18n.t('invoice.digitalGeneral'), value: '3' },
]

/**
 * 发票状态枚举
 * @enum {string}
 * @property {string} PENDING_APPLY - 0: 待申请
 * @property {string} APPLIED - 1: 已申请
 * @property {string} REJECTED - 2: 已拒绝
 * @property {string} PROCESSING - 3: 开票中
 * @property {string} PENDING_PROCESS - 4: 待处理
 * @property {string} PENDING_CONFIRMATION - 5: 待确认
 * @property {string} ISSUED - 6: 已开票
 */
export const INVOICE_STATUS = {
  PENDING_APPLY: '0',
  APPLIED: '1',
  REJECTED: '2',
  PROCESSING: '3',
  PENDING_PROCESS: '4',
  PENDING_CONFIRMATION: '5',
  ISSUED: '6',
}